import React from 'react'
import { Link } from 'react-router'
import { Box, Stack, Heading, Text, Button } from '@/components/lib'

import NotFoundImage from '../../images/notFound.png'

export default function NotFound () {
  return (
    <Box maxW='400px' mx='auto'>
      <Stack spacing={5}>
        <img src={NotFoundImage} alt='Page not found' />
        <Heading>Page not found</Heading>
        <Text>We're sorry, but the page you're trying to reach could not be found.</Text>
        <Button as={Link} to='/' colorPalette='primary'>Return home</Button>
      </Stack>
    </Box>
  )
}
